module.exports = __webpack_public_path__ + "images/icon_play_purple_73405bec08dc19e28380385f1723d101.png";